import countries from "assets/countries.json"

export const isAlpha = (/** @type {string} */ character) =>
  typeof character === "string" &&
  character.length === 1 &&
  /^[A-Z]$/i.test(character)

export const isEmail = (/** @type {string} */ emailAddress) =>
  /^(\+?|\w)+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(
    emailAddress,
  )

export const passwordPattern = /^(?=.*[a-z])(?=.*\d).{8,}$/

/**
 *
 * @param {{
 *  countryCode?: import("services/appCenter/data").TGiantUserInfo['countryCode']
 *  cityName?: import("services/appCenter/data").TGiantUserInfo['cityName']
 *  formattedAddress?: import("services/appCenter/data").TGiantUserInfo['formattedAddress']
 * }} userInfo
 */
export const getFullAddress = ({countryCode, cityName, formattedAddress}) => {
  let address = ""
  if (countryCode) {
    const country = countries.find(c => c.value === countryCode)
    if (country) address += country.text
  }
  if (cityName) {
    address += ` ${cityName}`
  }
  if (formattedAddress) {
    address += ` ${formattedAddress}`
  }
  return address
}

/**
 * @param {import("services/appCenter/data").TUserAddress=} address
 */
export const getFullDetailAddress = address => {
  const {
    country = "",
    city,
    street,
    district,
    stateProvince,
    zipcode,
  } = address || {}

  const countryName =
    countries.find(({value}) => country === value)?.text || "Country name"
  switch (country) {
    case "Japan":
    case "Taiwan":
    case "China":
    case "Korea":
      // East Asia format: country → zipcode → stateProvince/district/city → street
      return `${country} ${
        zipcode ? zipcode + " " : ""
      }${stateProvince}${city}${district}${street}`

    default:
      // West format: street → city → district → state → zipcode → country
      const parts = [
        street,
        district,
        city,
        stateProvince,
        zipcode,
        countryName,
      ].filter(part => part && part.length > 0)
      return parts.join(", ")
  }
}
